<template>
  <div class="cl">
    <div class="new_slide cl">
      <!-- 左右切换 -->
      <div class="swiper-container" id="s3" v-if="newsList.length > 0">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item, index) in newsList"
            :key="index"
          >
            <a
              :href="['/newsDetail?id=' + item.id + '&language=' + lang]"
              class="img_new_warp"
            >
              <div class="img_w">
                <img :src="item.cover_img" alt="" />
              </div>

              <div class="new_mask cl">
                <div class="title ell2">{{ item.title }}</div>
                <div class="date">{{ item.publish_time }}</div>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="prevCont">
        <!-- 如果需要导航按钮 -->
        <div class="swiper-button-prev nprev"></div>
        <div class="swiper-button-next nnext"></div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
export default {
  name: "NewsItem",
  components: {},
  props: ["newsList"],
  data() {
    return {
      lang: this.$route.query.language || "zh",
      isStop: false, //是否停止动画
      s3: "", //banner
      NewSlides: [],
    };
  },
  created() {
    var that = this;
    // <!--把window.onresize事件挂在到mounted函数上-->
    window.onresize = () => {
      console.log(document.documentElement.clientWidth);
    };
  },
  mounted() {},
  computed: {},
  methods: {
    sw() {
      let that = this;
      this.$nextTick(function () {
        that.s3 = new Swiper("#s3", {
          autoplay: false,
          loop: false,
          navigation: {
            nextEl: ".prevCont .nnext", //自动隐藏
            prevEl: ".prevCont .nprev", //自动隐藏
            hiddenClass: "btn-hidden", //某些情况下需要隐藏前进后退按钮时，可以设定一个自定义的类名。
          },
          breakpointsInverse: true,
          slidesPerView: 4,
          spaceBetween: 40,
          breakpoints: {
            0: {
              //当屏幕宽度大于等于320
              slidesPerView: 1,
              spaceBetween: 20,
            },
            800: {
              //当屏幕宽度大于等于320
              slidesPerView: 2,
              spaceBetween: 20,
            },
            1200: {
              //当屏幕宽度大于等于768
              slidesPerView: 3,
              spaceBetween: 20,
            },
            1930: {
              //当屏幕宽度大于等于1920
              slidesPerView: 4,
              spaceBetween: 20,
            },
          },
        });
      });
    },
    //跳转详情
    Detail(id) {
      this.$router.push({
        path: "/newsDetail",
        query: { id: id, language: this.lang },
      });
    },
  },
  watch: {
    newsList() {
      this.sw();
    },
  },
};
</script>
<style scoped>
.new_slide {
  overflow: hidden;
  margin: 0 auto;
  margin-top: 0;
  text-align: center;
  position: relative;
}

.swiper-button-prev.nprev:after,
.swiper-button-next.nnext:after {
  color: #fff;
  font-weight: 700;
}

.swiper-button-disabled.nnext,
.swiper-button-disabled.nprev {
  display: none;
}
.img_new_warp {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/NewsItem.vue